import { launchOTPAuth } from './otp';
import Logger from '../logger';

const actionHandlers = {
    relogin: () => {
        window.WC._localStorage.set('reloginRequestTimestamp', Date.now(), 'wc.relogin');
    },

    maximize_widget: () => {
        window.closer.openWidget();
    },
    authorize_sms: (args) => {
        launchOTPAuth(args);
    },
    redirect: (args) => {
        window.open(args.url, args.target);
    },
    cmb: (args) => {
        setTimeout(() => {
            if (args.isMOApp) {
                const el = document.querySelector('#closer-widget > div');
                if (el && el.style) {
                    el.style.zIndex = 101;
                }
            } else {
                window.closer.deinit();
            }
            window.OPLWCParent.genesysButtonHandler({
                target: {
                    innerText: 'Max CMB button',
                    dataset: {
                        userevent: 'widgetPopupGet',
                        attributesToSend: 'queue,opis',
                        queue: args?.queue ?? 'SALES_KONTAKT_B2C',
                        opis: `dialogueTag=${args?.dialogueTag}`,
                        preloaderType: 'popup'
                    }
                }
            });
        }, 500);
    },
    set_dialogueTag: (args) => {
        if (args.dialogueTag) {
            window.WC._cookies.setCookie('wc.lektaDialogueTag', args.dialogueTag);
        } else {
            Logger.error('no dialogueTag argument');
        }
    },
    close_chat: () => {
        window.WC?.sendEvent('wc_chat_close', { reason: 'closed by Max' });
        window.closer.deinit();
    }
};

const handleActions = (actions, handlers) => {
    actions.forEach((a) => {
        const handler = handlers[a.type];
        if (handler) {
            handler(a.args);
        } else {
            Logger.error(`unhandled action type: ${a.type}`);
        }
    });
};

const onLektaContextHandler = (context) => {
    Logger.log(`onLektaContextHandler -> context=${context ? JSON.stringify(context) : 'NA'}`);

    if (context.actions && Array.isArray(context.actions)) {
        handleActions(context.actions, actionHandlers);
    }
};

export { onLektaContextHandler, handleActions };
